import { useEffect } from "react";
import { Router } from "react-router-dom";
import { history, notification, SessionService } from "./services";
import { CacheContextProvider } from "./contexts/cache.context";
import "react-perfect-scrollbar/dist/css/styles.css";
import Routes from "./routes";
import { connect } from "react-redux";
import store from "./config/store";
import authActions from "./store/modules/notificacao/actions";
import { io } from "socket.io-client";
import { buscarNotificacao } from "./utils";

const App = ({ setMensagens }) => {
  const sessionService = new SessionService();

  useEffect(() => {
    if (store.enviroment == "production" || store.enviroment == "releasing") {
      const socket = io(store.notificationSocketUrl);
      try {
        window.__SAF_SOCKET = socket;
      } catch (err) {
        console.error("Error setting global socket reference", err);
      }
      const dados = sessionService.getEmpresaAndUsuario();
      const usuario = dados?.usuario;
      let empresa = dados?.empresa;

      socket.on("message", (data) => {
        if (usuario && data.pctUsuarioId == usuario.id) {
          buscarNotificacao(setMensagens, usuario.id);
          if (data.tipo == "ERRO") {
            notification.erroCadastroApi(data.titulo);
          } else {
            notification.alertaApi(data.descricao);
          }
        }
      });

      let registeredKanbanChannel = null;
      const registerKanbanChannel = (emp) => {
        if (!emp || !emp.id) return;
        const channel = `messageKanban-${emp.id}`;
        if (registeredKanbanChannel === channel) return;
        registeredKanbanChannel = channel;
        socket.on(channel, (data) => {
          if (data && data.empresaId === emp.id) {
            try {
              window.dispatchEvent(
                new CustomEvent("kanban:update", { detail: data }),
              );
            } catch (err) {
              console.error("Error dispatching kanban:update event", err);
            }
          }
        });
      };

      if (empresa && empresa.id) {
        registerKanbanChannel(empresa);
      }
      const sessionUpdatedHandler = (e) => {
        try {
          const dados = e?.detail;
          const emp = dados?.empresa;
          if (emp && emp.id) {
            registerKanbanChannel(emp);
          }
        } catch (err) {
          console.error("Error handling session:updated event in App.js", err);
        }
      };
      window.addEventListener("session:updated", sessionUpdatedHandler);
      return () => {
        try {
          if (window.__SAF_SOCKET === socket) delete window.__SAF_SOCKET;
        } catch (err) {
          console.error("Error clearing global socket reference", err);
        }
        try {
          window.removeEventListener("session:updated", sessionUpdatedHandler);
        } catch (err) {
          console.error(err);
        }
        try {
          if (registeredKanbanChannel) {
            socket.off(registeredKanbanChannel);
            registeredKanbanChannel = null;
          }
        } catch (err) {
          console.error("err", err);
        }
        socket.disconnect();
      };
    }
  }, []);

  return (
    <CacheContextProvider>
      <Router history={history}>
        <Routes />
      </Router>
    </CacheContextProvider>
  );
};

const mapStateToProps = (state) => ({
  mensagens: state.notificacao.mensagens,
});

const mapDispatchToProps = (dispatch) => ({
  setMensagens: (mensagens) => dispatch(authActions.setMensagens(mensagens)),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
